<template>
  <main class="main" role="main">
    <div class="main_con">
      <div class="search_box_wrap">
        <div class="search_box">
          <input
            ref="seach"
            type="text"
            placeholder="궁금한 내용을 검색해주세요"
            :value="keyword"
            @keyup.enter="saveRecentWord"
            @input="handleKeywords"
          />
          <i class="i_search pnt" @click="saveRecentWord"></i>
        </div>
        <!-- 검색어 리스트 -->
        <SearchList
          v-if="keyword && isSearching"
          :keyword="keyword"
          :keywords="keywords"
          @bind-word="bindWord"
        />
      </div>
      <div class="search__con">
        <!-- 검색어 입력 전 -->
        <SearchDefault
          v-if="!keyword && !isSearching"
          :recent-keywords="recentWords"
          @bind-word="bindWord"
          @delete-word="deleteWord"
          @check-apply="checkApply"
        />

        <!-- 검색어 입력 후 결과 O -->
        <SearchResult
          v-if="!isEmpty && this.$route.query.keyword"
          :data="searchData"
          :is-mobile-btn="isMobileBtn"
          :is-internet-btn="isInternetBtn"
          @check-apply="checkApply"
        />

        <!-- 검색어 입력 후 결과 X -->
        <EmptyData
          v-if="isEmpty && this.$route.query.keyword"
          @bind-word="bindWord"
          @check-apply="checkApply"
        />
      </div>
    </div>
    <DesignPopup2
      :show="designPopup"
      :data="{
        title: '견적 받아보기 안내',
        type: 'alert',
        msg: `최초 견적요청일로부터 일주일이 지나야만 재요청이 가능합니다.`,
      }"
      @close="popupClose"
    />
  </main>
</template>

<script>
import SearchDefault from './components/SearchDefault.vue';
import SearchList from './components/SearchList.vue';
import SearchResult from './components/SearchResult.vue';
import EmptyData from './components/EmptyData.vue';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';

import { mapActions as searchMapActions } from '@common/store/modules/search';
import * as searchTypes from '@common/store/modules/search/types';
import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import * as estimateTypes from '@common/store/modules/estimate/types';
import * as estimationTypes from '@common/store/modules/estimate/types';

import format from 'date-fns/format';

export default {
  name: 'search-index',
  description: '검색 인덱스 페이지',
  components: {
    SearchDefault,
    SearchList,
    SearchResult,
    EmptyData,
    DesignPopup2,
  },
  data() {
    return {
      keyword: '', // 검색어
      keywords: [], // 검색어 자동완성 리스트
      isSearching: false,
      recentWords: [], // 최근 검색어
      searchData: {
        storeCnt: 0,
        knowhowCnt: 0,
        boardCnt: 0,
        reviewCnt: 0,
        stores: [],
        knowhows: [],
        boards: [],
        reviews: [],
      },
      isEmpty: false,
      designPopup: false,
      mobileKeywords: [
        '휴대폰',
        '핸드폰',
        '모바일',
        '견적',
        '신청',
        '휴대폰 견적',
      ], // 휴대폰 견적 버튼 검색어
      internetKeywords: ['인터넷', '와이파이', '견적', '신청', '인터넷 신청'], //인터넷 견적 버튼 검색어
      isMobileBtn: false,
      isInternetBtn: false,
    };
  },
  computed: {
    ...internetMapGetters({
      internetCommerceIngList: internetTypes.INTERNET_COMMERCE_ING_LIST,
      internetCommerceEndList: internetTypes.INTERNET_COMMERCE_END_LIST,
      internetCommercUserQuotationNewList:
        internetTypes.INTERNET_COMMERCE_USER_QUOTATION_NEW,
    }),
    ...estimateMapGetters({
      estimationList: estimationTypes.ESTIMATION_LIST,
    }),
    ...mobileMapGetters({
      mobileRequestListIng: mobileTypes.MOBILE_REQUEST_LIST_ING,
      mobileRequestListEnd: mobileTypes.MOBILE_REQUEST_LIST_END,
    }),
  },
  async created() {
    // 새로고침 했을때 검색어 바인딩을 위해 추가
    const keyword = this.$route.query.keyword;
    if (keyword) {
      this.keyword = keyword;
      this.search();
    }
    // 최근 검색어
    this.recentWords =
      JSON.parse(localStorage.getItem('recent-keywords')) || [];
  },
  watch: {
    '$route.query.keyword'(val) {
      // 뒤로 가기 했을때 검색 기록 불러오기 위해 추가
      this.keyword = val;
      this.isSearching = false;
      if (val) {
        // 검색 기록이 있을때
        this.search();
      } else {
        // 검색 기록이 없을때
        console.log('NO SEARCH DATA');
      }
    },
  },
  methods: {
    ...searchMapActions([
      searchTypes.FETCH_SEARCH,
      searchTypes.FETCH_SEARCH_KEYWORDS,
    ]),
    ...internetMapActions([
      internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION,
      internetTypes.SELECT_INTERNET_COMMERCE_USER_QUOTATION_NEW,
      internetTypes.SELECT_INTERNET_PRODUCTS,
    ]),
    ...estimateMapActions([
      estimationTypes.FETCH_ESTIMATION_LIST,
      estimateTypes.ESTIMATION_MODEL_RESET_STATE,
    ]),
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_REQUEST_LIST_ING,
      mobileTypes.SELECT_MOBILE_REQUEST_LIST_END,
    ]),
    bindWord(val) {
      this.keyword = val;
      this.saveRecentWord();
    },
    saveRecentWord() {
      if (!this.keyword.trim()) return;

      this.recentWords.forEach((item, idx) => {
        if (item == this.keyword.trim()) this.recentWords.splice(idx, 1);
      });

      this.recentWords.unshift(this.keyword.trim());
      // 최근 검색어 저장은 3개까지
      if (this.recentWords.length > 3) this.recentWords.splice(3);
      localStorage.setItem('recent-keywords', JSON.stringify(this.recentWords));
      this.isSearching = false;
      this.search();
    },
    deleteWord(idx) {
      this.recentWords.splice(idx, 1);
      localStorage.setItem('recent-keywords', JSON.stringify(this.recentWords));
    },
    async handleKeywords(event) {
      // 검색창을 v-model로 사용할 경우 한글 타이핑시 이슈 발생
      const value = event.target.value;
      this.keyword = value;

      // clearTimeout(this.debounce);
      // this.debounce = setTimeout(() => {
      this.isSearching = true;

      if (this.keyword) {
        this[searchTypes.FETCH_SEARCH_KEYWORDS]({
          keyword: this.keyword,
        }).then(res => {
          console.log('resresresresres');
          console.log(res);
          if (res !== '') {
            this.keywords = res;
          } else {
            this.keywords = [];
          }
        });
      }
      // }, 300);
    },
    handleBlur(event) {
      console.log('handleBlur :: {}', event);
      this.$refs.serach.focus();
    },
    async search() {
      if (!this.keyword) return;
      const params = { keyword: this.keyword };
      await this[searchTypes.FETCH_SEARCH](params).then(res => {
        console.log('res :: {}', res);
        const data = res.content;
        this.searchData = data;
        if (data.stores?.length > 6) {
          this.searchData.stores = data.stores.slice(0, 5);
        }
        if (data.knowhows?.length > 6) {
          this.searchData.knowhows = data.knowhows.slice(0, 5);
        }
        if (data.boards?.length > 6) {
          this.searchData.boards = data.boards.slice(0, 5);
        }
        if (data.reviews?.length > 6) {
          this.searchData.reviews = data.reviews.slice(0, 5);
        }

        console.log('this.searchData.reviews');
        console.log(this.searchData.reviews);

        // 검색결과 데이터 여부
        if (
          !data.storeCnt &&
          !data.knowhowCnt &&
          !data.boardCnt &&
          !data.reviewCnt &&
          !this.isMobileBtn &&
          !this.isInternetBtn
        ) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }

        // 견적 버튼 체크
        this.checkMobileBtn();
        this.checkInternetBtn();

        // 페이지 이동
        this.$router
          .push({ name: 'Search', query: { keyword: this.keyword } })
          .catch(() => {});
      });
    },
    /* 인터넷, 휴대폰 견적 가능 여부 체크 */
    checkApply(type) {
      if (type === 'INTERNET_APPLY' || type === 'SKYLIFE') {
        this.checkInternet(type);
      } else if (type === 'MOBILE_APPLY') {
        this.checkMobile();
      }
    },
    async checkInternet(type) {
      let goCreateCheck = true;
      const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');

      await this.getInternetCommerceEndList();

      // 인터넷 견적을 생성한지 일주일이 지나야만 재요청이 가능하다 (최대 2건)
      if (this.internetCommerceIngList.content.length >= 2) {
        goCreateCheck = false;
      } else if (this.internetCommerceIngList.content.length == 1) {
        if (this.internetCommerceEndList.content.length >= 1) {
          const createdAt = new Date(
            this.internetCommerceEndList.content[0].createdAt,
          );

          const sDays = format(
            new Date(createdAt.setDate(createdAt.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          // 안지났음
          if (now < sDays) {
            goCreateCheck = false;
          } else {
            goCreateCheck = true;
          }
        } else {
          goCreateCheck = true;
        }
      } else if (this.internetCommerceIngList.content.length == 0) {
        if (this.internetCommerceEndList.content.length >= 2) {
          const createdAt_1 = new Date(
            this.internetCommerceEndList.content[0].createdAt,
          );

          const sDays_1 = format(
            new Date(createdAt_1.setDate(createdAt_1.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          const createdAt_2 = new Date(
            this.internetCommerceEndList.content[1].createdAt,
          );

          const sDays_2 = format(
            new Date(createdAt_2.setDate(createdAt_2.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          // 둘다 안지났음
          if (now < sDays_1 && now < sDays_2) {
            goCreateCheck = false;
          } else {
            goCreateCheck = true;
          }
        } else {
          goCreateCheck = true;
        }
      } else {
        goCreateCheck = true;
      }

      if (goCreateCheck) {
        if (type === 'INTERNET_APPLY') {
          this.$router.push({ name: 'InternetCommerce.Create' });
        } else {
          this.$router.push({ name: 'InternetCommerce.Skylife' });
        }
      } else {
        this.designPopup = true;
      }
    },
    async checkMobile() {
      let params = {
        callPart: 'CUSTOMER',
        status: 'ING',
      };
      await this[mobileTypes.SELECT_MOBILE_REQUEST_LIST_ING](params);

      let paramsEnd = {
        callPart: 'CUSTOMER',
        status: 'END',
      };
      await this[mobileTypes.SELECT_MOBILE_REQUEST_LIST_END](paramsEnd);
      let goCreateCheck = true;

      const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');

      // 휴대폰 견적을 생성한지 일주일이 지나야만 재요청이 가능하다 (최대 3건)
      if (this.mobileRequestListIng.content.length >= 3) {
        goCreateCheck = false;
      } else if (this.mobileRequestListIng.content.length == 2) {
        if (this.mobileRequestListEnd.content.length > 0) {
          const requestedAt = new Date(
            this.mobileRequestListEnd.content[0].requestedAt,
          );

          const sDays = format(
            new Date(requestedAt.setDate(requestedAt.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          // 안지났음
          if (now < sDays) {
            goCreateCheck = false;
          } else {
            goCreateCheck = true;
          }
        } else {
          goCreateCheck = true;
        }
      } else if (this.mobileRequestListIng.content.length == 1) {
        if (this.mobileRequestListEnd.content.length > 1) {
          const requestedAt_1 = new Date(
            this.mobileRequestListEnd.content[0].requestedAt,
          );

          const sDays_1 = format(
            new Date(requestedAt_1.setDate(requestedAt_1.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          const requestedAt_2 = new Date(
            this.mobileRequestListEnd.content[1].requestedAt,
          );

          const sDays_2 = format(
            new Date(requestedAt_2.setDate(requestedAt_2.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          // 둘다 안지남
          if (now < sDays_1 && now < sDays_2) {
            goCreateCheck = false;
          } else {
            goCreateCheck = true;
          }
        } else {
          goCreateCheck = true;
        }
      } else if (this.mobileRequestListIng.content.length == 0) {
        if (this.mobileRequestListEnd.content.length > 2) {
          const requestedAt_1 = new Date(
            this.mobileRequestListEnd.content[0].requestedAt,
          );

          const sDays_1 = format(
            new Date(requestedAt_1.setDate(requestedAt_1.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          const requestedAt_2 = new Date(
            this.mobileRequestListEnd.content[1].requestedAt,
          );

          const sDays_2 = format(
            new Date(requestedAt_2.setDate(requestedAt_2.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          const requestedAt_3 = new Date(
            this.mobileRequestListEnd.content[2].requestedAt,
          );

          const sDays_3 = format(
            new Date(requestedAt_3.setDate(requestedAt_3.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          // 셋다 안지남
          if (now < sDays_1 && now < sDays_2 && now < sDays_3) {
            goCreateCheck = false;
          } else {
            goCreateCheck = true;
          }
        } else {
          goCreateCheck = true;
        }
      } else {
        goCreateCheck = true;
      }

      if (goCreateCheck) {
        this.$router.push({ name: 'Mobile.Create' });
      } else {
        this.designPopup = true;
      }
    },
    async getInternetCommerceEndList() {
      await this[internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION]({
        page: this.page,
        size: this.size,
        status: 'END',
        orderType: 'CREATED_AT_DESC',
      });
    },
    popupClose() {
      this.designPopup = false;
    },
    /* ----------------------------------- */
    checkMobileBtn() {
      if (this.mobileKeywords.indexOf(this.keyword) > -1) {
        this.isMobileBtn = true;
      } else {
        this.isMobileBtn = false;
      }
    },
    checkInternetBtn() {
      if (this.internetKeywords.indexOf(this.keyword) > -1) {
        this.isInternetBtn = true;
      } else {
        this.isInternetBtn = false;
      }
    },
  },
};
</script>
